import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { imgUrl, fmtDate } from "@/lib/api";

export const Rating = ({ value, count, testid }) => (
  <span className="inline-flex items-center gap-1 text-sm font-medium" data-testid={testid}>
    <Star className="h-4 w-4 fill-stone-900 text-stone-900" />
    {value ? value.toFixed(2) : "New"}
    {count > 0 && <span className="font-normal text-stone-500">({count})</span>}
  </span>
);

export const StarInput = ({ value, onChange }) => (
  <div className="flex gap-1" data-testid="star-input">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" data-testid={`star-input-${n}`} onClick={() => onChange(n)} className="transition-transform hover:scale-110">
        <Star className={`h-7 w-7 ${n <= value ? "fill-amber-400 text-amber-400" : "text-stone-300"}`} />
      </button>
    ))}
  </div>
);

export const ReviewItem = ({ r }) => (
  <div className="space-y-2" data-testid={`review-${r.review_id}`}>
    <div className="flex items-center gap-3">
      <Avatar className="h-10 w-10">
        <AvatarImage src={imgUrl(r.author?.picture)} />
        <AvatarFallback>{r.author?.name?.[0]}</AvatarFallback>
      </Avatar>
      <div>
        <Link to={`/users/${r.author_id}`} className="font-semibold hover:underline">{r.author?.name}</Link>
        <p className="text-xs text-stone-500">{fmtDate(r.created_at)}</p>
      </div>
      <span className="ml-auto flex">
        {Array.from({ length: r.rating }, (_, n) => `star-${n + 1}`).map((k) => <Star key={k} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />)}
      </span>
    </div>
    <p className="text-sm leading-relaxed text-stone-700">{r.comment}</p>
  </div>
);
